module.exports = __webpack_public_path__ + "img/banner_02.58617cbe.jpeg";